import { integrationOptionProvider } from "@p0security/integrations-installer";

import type { RdpInstaller } from "./types.ts";

export const rdpInstaller: RdpInstaller = {
  components: {
    "iam-write": {
      optionProvider: integrationOptionProvider("iam-write", [
        {
          component: "iam-write",
          integration: "azure",
          keyPrefix: "azure",
        },
      ]),
    },
  },
};
